<template>
    <td-dialog
        v-dialogDrag
        :title="$t(title)"
        :before-close="mqCasDialogClose"
        :visible.sync="dialogMqVisible"
        :width="dialogWidth"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form :model="formMqCasCadeInfo" :label-position="right" :label-width="formLabelWidth" ref="formMqCasCadeInfo" :rules="rules">
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item :label="$t('common.FROM_CHANNEL')" prop="sFromChannelId">
                        <td-select v-model="formMqCasCadeInfo.sFromChannelId" :options="options" pageSize="6" @change="fromchange" keys="sFromChannelId" text="sFromChannel"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" :class="{ 'el-col_display': flag1 }">
                    <el-form-item :label="$t('common.FROM_ROUTINGKEY')" prop="sFromRoutingkey">
                        <td-input v-model="formMqCasCadeInfo.sFromRoutingkey"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item :label="$t('common.TO_CHANNEL')" prop="sToChannelId">
                        <td-select v-model="formMqCasCadeInfo.sToChannelId" :options="options" pageSize="6" @change="tochange" keys="sFromChannelId" text="sFromChannel"></td-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" :class="{ 'el-col_display': flag2 }">
                    <el-form-item :label="$t('common.TO_ROUTINGKEY')" prop="sToRoutingkey">
                        <td-input v-model="formMqCasCadeInfo.sToRoutingkey"></td-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="loading" @click="submitForm('formMqCasCadeInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="mqCasDialogClose">{{ $t('common.CANCAL') }}</td-button>
        </span>
        <dialog-Message
            v-if="dialogMessageVisible"
            :statusMessage="statusMessage"
            :content="content"
            :dialogMessageVisible="dialogMessageVisible"
            @messageDialogClose="messageDialogClose"
        ></dialog-Message>
    </td-dialog>
</template>
<script>
import mqCasApi from '../assets/api.js';
import dialogMessage from '../components/dialogMessage.vue';
export default {
    props: ['title', 'dialogMqVisible', 'editItem', 'isAddData'],
    components: {
        'dialog-Message': dialogMessage
    },
    created() {
        this.initMqChannelData();
    },
    // 定义变量
    data() {
        return {
            loading: false, // 保存按钮loading状态
            flag1: true, // 源关键字是否增加css样式
            flag2: true, // 目标关键字是否增加css样式
            formLabelWidth: '60%',
            dialogWidth: '320px',
            dialogMessageVisible: false,
            formMqCasCadeInfo: {
                // mq级联对象
                sId: '',
                sFromChannelId: '',
                sFromChannelName: '',
                sToChannelId: '',
                sToChannelName: '',
                sFromMqId: '',
                sFromMqName: '',
                sToMqId: '',
                sToMqName: '',
                sFromChannel: '',
                sToChannel: '',
                sCascadeId: '',
                iFromMode: 0,
                iToMode: 0,
                sFromRoutingkey: '',
                sToRoutingkey: ''
            },
            options: [],
            // 对表单进行数据验证
            rules: {
                sFromChannelId: [{ required: true, message: this.$t('error.ERROR_CHOOSE_CHANNEL_NULL'), trigger: 'change' }],
                sToChannelId: [{ required: true, message: this.$t('error.ERROR_CHOOSE_CHANNEL_NULL'), trigger: 'change' }],
                sFromRoutingkey: [
                    { required: true, message: this.$t('pgError.ERROR_INPUT_ROUTINGKEY'), trigger: 'blur' },
                    { pattern: this.$regex.ROUTING_KEY_RULE, message: this.$t('error.ERROR_ROUTING_KEY_ILLEGAL') }
                ],
                sToRoutingkey: [
                    { required: true, message: this.$t('pgError.ERROR_INPUT_ROUTINGKEY'), trigger: 'blur' },
                    { pattern: this.$regex.ROUTING_KEY_RULE, message: this.$t('error.ERROR_ROUTING_KEY_ILLEGAL') }
                ]
            }
        };
    },
    methods: {
        // 源通道change事件
        fromchange(value) {
            for (let i = 0; i < this.options.length; i++) {
                if (value === this.options[i].sFromChannelId) {
                    this.formMqCasCadeInfo.sFromChannelId = this.options[i].sFromChannelId;
                    this.formMqCasCadeInfo.sFromChannelName = this.options[i].sFromChannelName;
                    this.formMqCasCadeInfo.sFromMqId = this.options[i].sFromMqId;
                    this.formMqCasCadeInfo.sFromMqName = this.options[i].sFromMqName;
                    this.formMqCasCadeInfo.sFromChannel = this.options[i].sFromChannel;
                    this.formMqCasCadeInfo.iFromMode = this.options[i].iFromMode;
                    // 判断是否实际改变了值
                    if (
                        !this.isAddData &&
                        this.formMqCasCadeInfo.sFromChannelId === this.editItem.sFromChannelId &&
                        this.formMqCasCadeInfo.sFromMqId === this.editItem.sFromMqId &&
                        this.formMqCasCadeInfo.sToChannelId === this.editItem.sToChannelId &&
                        this.formMqCasCadeInfo.sToMqId === this.editItem.sToMqId
                    ) {
                        this.formMqCasCadeInfo.sFromRoutingkey = this.editItem.sFromRoutingkey;
                        this.formMqCasCadeInfo.sToRoutingkey = this.editItem.sToRoutingkey;
                    } else {
                        this.formMqCasCadeInfo.sFromRoutingkey = '';
                    }
                    this.checkRoutingKey();
                    break;
                }
            }
        },
        // 目标通道change事件
        tochange(value) {
            for (let i = 0; i < this.options.length; i++) {
                if (value === this.options[i].sFromChannelId) {
                    this.formMqCasCadeInfo.sToChannelId = this.options[i].sFromChannelId;
                    this.formMqCasCadeInfo.sToChannelName = this.options[i].sFromChannelName;
                    this.formMqCasCadeInfo.sToMqId = this.options[i].sFromMqId;
                    this.formMqCasCadeInfo.sToMqName = this.options[i].sFromMqName;
                    this.formMqCasCadeInfo.sToChannel = this.options[i].sFromChannel;
                    this.formMqCasCadeInfo.iToMode = this.options[i].iFromMode;
                    // 判断是否实际改变了值
                    if (
                        !this.isAddData &&
                        this.formMqCasCadeInfo.sFromChannelId === this.editItem.sFromChannelId &&
                        this.formMqCasCadeInfo.sFromMqId === this.editItem.sFromMqId &&
                        this.formMqCasCadeInfo.sToChannelId === this.editItem.sToChannelId &&
                        this.formMqCasCadeInfo.sToMqId === this.editItem.sToMqId
                    ) {
                        this.formMqCasCadeInfo.sFromRoutingkey = this.editItem.sFromRoutingkey;
                        this.formMqCasCadeInfo.sToRoutingkey = this.editItem.sToRoutingkey;
                    } else {
                        this.formMqCasCadeInfo.sToRoutingkey = '';
                    }
                    this.checkRoutingKey();
                    break;
                }
            }
        },
        // 提交表单
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.loading = true;
                    if (!this.checkData()) {
                        this.loading = false;
                        return;
                    }
                    this.checkMqChannerCascade();
                }
            });
        },
        // 校验数据
        checkData() {
            if (this.formMqCasCadeInfo.sFromChannelId === this.formMqCasCadeInfo.sToChannelId) {
                this.$message({ showClose: true, message: this.$t('error.ERROR_FROM_TO_CHANNEL_SAME'), type: 'error' });
                return false;
            }
            if (this.formMqCasCadeInfo.sFromMqId === this.formMqCasCadeInfo.sToMqId) {
                this.$message({ showClose: true, message: this.$t('error.ERROR_FROM_TO_MQ_SAME'), type: 'error' });
                return false;
            }
            return true;
        },
        // 检查mq级联关系是否存在
        checkMqChannerCascade() {
            // 判断是否实际改变了值
            if (
                !this.isAddData &&
                this.formMqCasCadeInfo.sFromChannelId === this.editItem.sFromChannelId &&
                this.formMqCasCadeInfo.sFromMqId === this.editItem.sFromMqId &&
                this.formMqCasCadeInfo.sToChannelId === this.editItem.sToChannelId &&
                this.formMqCasCadeInfo.sToMqId === this.editItem.sToMqId &&
                this.formMqCasCadeInfo.sToRoutingkey === this.editItem.sToRoutingkey &&
                this.formMqCasCadeInfo.sFromRoutingkey === this.editItem.sFromRoutingkey
            ) {
                this.mqCasDialogClose();
                this.loading = false;
                return;
            }
            mqCasApi.checkMqChannerCascade(JSON.stringify(this.formMqCasCadeInfo), response => {
                this.loading = false;
                if (response.status === undefined) {
                    return;
                }
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    this.$log.error('/mqCascadeManager/checkMqChannerCascade', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/mqCascadeManager/checkMqChannerCascade', response.data.statusMessage);
                    return;
                }
                // 添加
                if (this.isAddData) {
                    this.addDta();
                } else {
                    this.updateData();
                }
            });
        },

        // 添加信息
        addDta() {
            mqCasApi.addMqChannerCascade(JSON.stringify(this.formMqCasCadeInfo), response => {
                this.loading = false;
                if (response.status === undefined) {
                    return;
                }
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    this.$log.error('/mqCascadeManager/getMqChannerList', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.showMessage(response.data.statusMessage, response.data.content);
                    this.$log.error('/mqCascadeManager/getMqChannerList', response.data.statusMessage);
                    return;
                }
                this.mqCasDialogClose();
                this.$emit('queryList');
            });
        },
        // 修改信息
        updateData() {
            this.formMqCasCadeInfo.sId = this.editItem.sId;
            mqCasApi.updateMqChannerCascade(JSON.stringify(this.formMqCasCadeInfo), response => {
                this.loading = false;
                if (response.status === undefined) {
                    return;
                }
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    this.$log.error('/mqCascadeManager/getMqChannerList', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.showMessage(response.data.statusMessage, response.data.content);
                    this.$log.error('/mqCascadeManager/getMqChannerList', response.data.statusMessage);
                    return;
                }
                this.mqCasDialogClose();
                this.$emit('queryList');
            });
        },
        // 回显绑定信息
        initEditData() {
            this.formMqCasCadeInfo.sFromChannelId = this.editItem.sFromChannelId;
            this.formMqCasCadeInfo.sFromChannelName = this.editItem.sFromChannelName;
            this.formMqCasCadeInfo.sFromMqId = this.editItem.sFromMqId;
            this.formMqCasCadeInfo.sFromMqName = this.editItem.sFromMqName;
            this.formMqCasCadeInfo.sFromChannel = this.editItem.sFromChannel;
            this.formMqCasCadeInfo.sToChannelId = this.editItem.sToChannelId;
            this.formMqCasCadeInfo.sToChannelName = this.editItem.sToChannelName;
            this.formMqCasCadeInfo.sToMqId = this.editItem.sToMqId;
            this.formMqCasCadeInfo.sToMqName = this.editItem.sToMqName;
            this.formMqCasCadeInfo.sToChannel = this.editItem.sToChannel;
            this.formMqCasCadeInfo.iFromMode = this.editItem.iFromMode;
            this.formMqCasCadeInfo.iToMode = this.editItem.iToMode;
            this.formMqCasCadeInfo.sFromRoutingkey = this.editItem.sFromRoutingkey;
            this.formMqCasCadeInfo.sToRoutingkey = this.editItem.sToRoutingkey;
            this.formMqCasCadeInfo.sCascadeId = this.editItem.sCascadeId;
            this.checkRoutingKey();
        },
        // 初始化通道下拉列表数据
        initMqChannelData() {
            mqCasApi.getMqChannerList({}, response => {
                if (response.status === undefined) {
                    return;
                }
                if (response.status !== window.pgCommon.login.RESPONSE_STATUS) {
                    this.$message({ showClose: true, message: this.$t('error.ERROR_RESPONSE'), type: 'error' });
                    this.$log.error('/mqCascadeManager/getMqChannerList', response);
                    return;
                }
                if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/mqCascadeManager/getMqChannerList', response.data.statusMessage);
                    return;
                }
                this.options = response.data.content;
                if (!this.isAddData) {
                    this.initEditData();
                } else {
                    this.formMqCasCadeInfo.sFromChannelId = this.options[0].sFromChannelId;
                    this.formMqCasCadeInfo.sFromChannelName = this.options[0].sFromChannelName;
                    this.formMqCasCadeInfo.sFromMqId = this.options[0].sFromMqId;
                    this.formMqCasCadeInfo.sFromMqName = this.options[0].sFromMqName;
                    this.formMqCasCadeInfo.sFromChannel = this.options[0].sFromChannel;
                    this.formMqCasCadeInfo.sToChannelId = this.options[0].sFromChannelId;
                    this.formMqCasCadeInfo.sToChannelName = this.options[0].sFromChannelName;
                    this.formMqCasCadeInfo.sToMqId = this.options[0].sFromMqId;
                    this.formMqCasCadeInfo.sToMqName = this.options[0].sFromMqName;
                    this.formMqCasCadeInfo.sToChannel = this.options[0].sFromChannel;
                    this.formMqCasCadeInfo.iFromMode = this.options[0].iFromMode;
                    this.formMqCasCadeInfo.iToMode = this.options[0].iFromMode;
                    this.checkRoutingKey();
                }
            });
        },
        // 检测并控制路由关键字输入框是否出现
        checkRoutingKey() {
            let fromFlag = false;
            // 判断是否显示路由关键字
            if (this.formMqCasCadeInfo.iFromMode === window.pgCommon.mqChannelType.MQCHANNELTYPE_DIRECT || this.formMqCasCadeInfo.iFromMode === window.pgCommon.mqChannelType.MQCHANNELTYPE_TOPIC) {
                fromFlag = true;
                this.flag1 = false;
            } else {
                fromFlag = false;
                this.flag1 = true;
            }
            let toFlag = false;
            if (this.formMqCasCadeInfo.iToMode === window.pgCommon.mqChannelType.MQCHANNELTYPE_DIRECT || this.formMqCasCadeInfo.iToMode === window.pgCommon.mqChannelType.MQCHANNELTYPE_TOPIC) {
                toFlag = true;
                this.flag2 = false;
            } else {
                toFlag = false;
                this.flag2 = true;
            }
            if (fromFlag || toFlag) {
                this.formLabelWidth = '32%';
                this.dialogWidth = '640px';
            } else {
                this.formLabelWidth = '60%';
                this.dialogWidth = '320px';
            }
            if (!this.flag1 && !this.flag2) {
                this.rules = {
                    sFromChannelId: [{ required: true, message: this.$t('error.ERROR_CHOOSE_CHANNEL_NULL'), trigger: 'change' }],
                    sToChannelId: [{ required: true, message: this.$t('error.ERROR_CHOOSE_CHANNEL_NULL'), trigger: 'change' }],
                    sFromRoutingkey: [
                        { required: true, message: this.$t('pgError.ERROR_INPUT_ROUTINGKEY'), trigger: 'blur' },
                        { pattern: this.$regex.ROUTING_KEY_RULE, message: this.$t('error.ERROR_ROUTING_KEY_ILLEGAL') }
                    ],
                    sToRoutingkey: [
                        { required: true, message: this.$t('pgError.ERROR_INPUT_ROUTINGKEY'), trigger: 'blur' },
                        { pattern: this.$regex.ROUTING_KEY_RULE, message: this.$t('error.ERROR_ROUTING_KEY_ILLEGAL') }
                    ]
                };
            } else if (!this.flag1 && this.flag2) {
                this.rules = {
                    sFromChannelId: [{ required: true, message: this.$t('error.ERROR_CHOOSE_CHANNEL_NULL'), trigger: 'change' }],
                    sToChannelId: [{ required: true, message: this.$t('error.ERROR_CHOOSE_CHANNEL_NULL'), trigger: 'change' }],
                    sFromRoutingkey: [
                        { required: true, message: this.$t('pgError.ERROR_INPUT_ROUTINGKEY'), trigger: 'blur' },
                        { pattern: this.$regex.ROUTING_KEY_RULE, message: this.$t('error.ERROR_ROUTING_KEY_ILLEGAL') }
                    ]
                };
            } else if (this.flag1 && !this.flag2) {
                this.rules = {
                    sFromChannelId: [{ required: true, message: this.$t('error.ERROR_CHOOSE_CHANNEL_NULL'), trigger: 'change' }],
                    sToChannelId: [{ required: true, message: this.$t('error.ERROR_CHOOSE_CHANNEL_NULL'), trigger: 'change' }],
                    sToRoutingkey: [
                        { required: true, message: this.$t('pgError.ERROR_INPUT_ROUTINGKEY'), trigger: 'blur' },
                        { pattern: this.$regex.ROUTING_KEY_RULE, message: this.$t('error.ERROR_ROUTING_KEY_ILLEGAL') }
                    ]
                };
            } else {
                this.rules = {
                    sFromChannelId: [{ required: true, message: this.$t('error.ERROR_CHOOSE_CHANNEL_NULL'), trigger: 'change' }],
                    sToChannelId: [{ required: true, message: this.$t('error.ERROR_CHOOSE_CHANNEL_NULL'), trigger: 'change' }]
                };
            }
        },
        // 关闭窗口之前需要调用的方法
        mqCasDialogClose() {
            this.$emit('mqCasDialogClose');
            this.$refs['formMqCasCadeInfo'].resetFields(); // 重置表单数据
        },
        showMessage(statusMessage, content) {
            this.dialogMessageVisible = true;
            //失败提示
            this.statusMessage = statusMessage;
            //失败原因
            this.content = content;
            console.info(this.content);
        },
        messageDialogClose() {
            this.dialogMessageVisible = false;
        }
    }
};
</script>
<style scoped>
>>> .el-form-item__error {
    width: 175px;
}
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.el-col_display {
    display: none;
}
</style>
